var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _circle, _path8, _circle2, _ellipse, _mask, _g2, _ellipse2, _mask2, _g3, _path9, _rect, _path10, _mask3, _g4, _path11, _path12, _path13, _path14, _circle3, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllNoEventsstyled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 159C39 209.098 64.0976 338.162 131.299 291.831C198.5 245.5 301.5 258 301.5 165.5C301.5 105.295 287.5 82 177.055 82C66.61 82 39 97.0368 39 159Z",
    fill: "var(--color-theme_clubNavigation1, var(--color-theme_clubNavigation1-override, rgba(51,51,51,1)))",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.5 136.31V147.31C282.5 149.756 281.397 152.134 279.317 154.41L274.878 193.944C274.633 196.127 273.677 198.159 271.926 199.486C263.899 205.568 235.785 222.31 169.5 222.31C103.215 222.31 75.1009 205.568 67.0739 199.486C65.323 198.159 64.3672 196.127 64.1221 193.944L59.6831 154.41C57.6026 152.134 56.5 149.756 56.5 147.31V136.31C56.5 119.742 107.092 106.31 169.5 106.31C231.908 106.31 282.5 119.742 282.5 136.31Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.317 154.41L274.888 150.362C274.033 151.298 273.496 152.48 273.354 153.74L279.317 154.41ZM274.878 193.944L268.915 193.275V193.275L274.878 193.944ZM271.926 199.486L268.302 194.703L268.302 194.703L271.926 199.486ZM67.0739 199.486L70.6977 194.703L67.0739 199.486ZM64.1221 193.944L70.0846 193.275L64.1221 193.944ZM59.6831 154.41L65.6457 153.74C65.5042 152.48 64.9672 151.298 64.1118 150.362L59.6831 154.41ZM288.5 147.31V136.31H276.5V147.31H288.5ZM283.746 158.458C286.5 155.445 288.5 151.688 288.5 147.31H276.5C276.5 147.824 276.295 148.823 274.888 150.362L283.746 158.458ZM273.354 153.74L268.915 193.275L280.84 194.614L285.279 155.079L273.354 153.74ZM268.915 193.275C268.812 194.193 268.474 194.573 268.302 194.703L275.55 204.268C278.88 201.744 280.453 198.061 280.84 194.614L268.915 193.275ZM268.302 194.703C261.511 199.85 234.741 216.31 169.5 216.31V228.31C236.83 228.31 266.288 211.286 275.55 204.268L268.302 194.703ZM169.5 216.31C104.259 216.31 77.4895 199.85 70.6977 194.703L63.4501 204.268C72.7122 211.286 102.17 228.31 169.5 228.31V216.31ZM70.6977 194.703C70.5256 194.573 70.1877 194.193 70.0846 193.275L58.1595 194.614C58.5467 198.061 60.1204 201.744 63.4501 204.268L70.6977 194.703ZM70.0846 193.275L65.6457 153.74L53.7206 155.079L58.1595 194.614L70.0846 193.275ZM50.5 147.31C50.5 151.688 52.5002 155.445 55.2544 158.458L64.1118 150.362C62.7051 148.823 62.5 147.824 62.5 147.31H50.5ZM50.5 136.31V147.31H62.5V136.31H50.5ZM169.5 100.31C137.931 100.31 109.139 103.701 88.0574 109.298C77.5607 112.084 68.6345 115.506 62.1903 119.551C56.0527 123.403 50.5 128.913 50.5 136.31H62.5C62.5 135.423 63.2713 133.04 68.5699 129.715C73.5619 126.581 81.1842 123.538 91.1365 120.896C110.953 115.635 138.661 112.31 169.5 112.31V100.31ZM288.5 136.31C288.5 128.913 282.947 123.403 276.81 119.551C270.366 115.506 261.439 112.084 250.943 109.298C229.861 103.701 201.069 100.31 169.5 100.31V112.31C200.339 112.31 228.047 115.635 247.863 120.896C257.816 123.538 265.438 126.581 270.43 129.715C275.729 133.04 276.5 135.423 276.5 136.31H288.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2594 148.636L64.1221 191.944C64.3672 194.127 65.3231 196.159 67.074 197.486C75.1009 203.568 103.215 220.31 169.5 220.31C235.785 220.31 263.899 203.568 271.926 197.486C273.677 196.159 274.633 194.127 274.878 191.944L279.741 148.636C270.358 162.664 224.571 173.31 169.5 173.31C114.429 173.31 68.6419 162.664 59.2594 148.636Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M258 206.064L261.5 163.064L276.5 157.064L273 198.064L258 206.064Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 174.064C68.7502 180.065 89.7887 190.565 127.563 195.44M276 174.064C270.25 180.065 250.961 190.565 214 195.44",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 163.064C70.0841 170.731 104.806 186.064 171.019 186.064C237.232 186.064 269.262 170.731 277 163.064",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 184.064C68.7166 190.532 89.5797 201.827 127 207.142M276 184.064C270.224 190.594 250.788 202.043 213.5 207.292",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "3 8"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59 149.064L63.8627 192.373C64.1078 194.556 65.0637 196.587 66.8146 197.914C74.8415 203.997 102.955 220.739 169.241 220.739C235.526 220.739 263.64 203.997 271.667 197.914C273.418 196.587 274.373 194.556 274.619 192.373L279.481 149.064C270.099 163.093 224.311 173.739 169.241 173.739C114.17 173.739 68.3825 163.093 59 149.064Z",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127 218.064V196.534C127 194.149 129.063 192.281 131.438 192.485C138.285 193.071 152.53 194.064 170.5 194.064C188.47 194.064 202.715 193.071 209.562 192.485C211.937 192.281 214 194.149 214 196.534V218.064",
    stroke: "black",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 204.311,
    r: 3,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171 193.064V221.064",
    stroke: "black",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 204.311,
    r: 3,
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.336,
    cy: 143.323,
    rx: 112.836,
    ry: 30.4523,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_lNpSezWOyvGv3Zu0fTmcJ2lZD0iUyhQfBHiDY76SSg",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 132,
    width: 229,
    height: 45
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282.5 134.31H56.5V145.31C56.5 161.879 107.092 175.31 169.5 175.31C231.908 175.31 282.5 161.879 282.5 145.31V134.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 134.31V132.81C55.6716 132.81 55 133.482 55 134.31H56.5ZM282.5 134.31H284C284 133.482 283.328 132.81 282.5 132.81V134.31ZM56.5 135.81H282.5V132.81H56.5V135.81ZM58 145.31V134.31H55V145.31H58ZM169.5 173.81C138.387 173.81 110.273 170.46 89.9818 165.073C79.8254 162.377 71.7141 159.192 66.1775 155.717C60.5643 152.194 58 148.638 58 145.31H55C55 150.266 58.7597 154.603 64.5827 158.258C70.4823 161.961 78.9195 165.241 89.212 167.973C109.819 173.444 138.205 176.81 169.5 176.81V173.81ZM281 145.31C281 148.638 278.436 152.194 272.822 155.717C267.286 159.192 259.175 162.377 249.018 165.073C228.727 170.46 200.613 173.81 169.5 173.81V176.81C200.795 176.81 229.181 173.444 249.788 167.973C260.08 165.241 268.518 161.961 274.417 158.258C280.24 154.603 284 150.266 284 145.31H281ZM281 134.31V145.31H284V134.31H281Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_lNpSezWOyvGv3Zu0fTmcJ2lZD0iUyhQfBHiDY76SSg)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 72,
    y: 137.064,
    width: 211,
    height: 41,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 134.31V132.31C55.3954 132.31 54.5 133.205 54.5 134.31H56.5ZM282.5 134.31H284.5C284.5 133.205 283.605 132.31 282.5 132.31V134.31ZM56.5 136.31H282.5V132.31H56.5V136.31ZM58.5 145.31V134.31H54.5V145.31H58.5ZM169.5 173.31C138.418 173.31 110.348 169.963 90.1101 164.59C79.9764 161.9 71.9194 158.731 66.4434 155.293C60.8651 151.792 58.5 148.367 58.5 145.31H54.5C54.5 150.537 58.4589 155.004 64.3168 158.681C70.277 162.422 78.7685 165.718 89.0837 168.456C109.744 173.941 138.174 177.31 169.5 177.31V173.31ZM280.5 145.31C280.5 148.367 278.135 151.792 272.557 155.293C267.081 158.731 259.024 161.9 248.89 164.59C228.652 169.963 200.582 173.31 169.5 173.31V177.31C200.826 177.31 229.256 173.941 249.916 168.456C260.231 165.718 268.723 162.422 274.683 158.681C280.541 155.004 284.5 150.537 284.5 145.31H280.5ZM280.5 134.31V145.31H284.5V134.31H280.5Z",
    fill: "black"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.5,
    cy: 134.31,
    rx: 113,
    ry: 30,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1_lNpSezWOyvGv3Zu0fTmcJ2lZD0iUyhQfBHiDY76SSg",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 110,
    width: 193,
    height: 45
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.5,
    cy: 132.31,
    rx: 96,
    ry: 22.08,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_lNpSezWOyvGv3Zu0fTmcJ2lZD0iUyhQfBHiDY76SSg)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 169.5,
    cy: 132.31,
    rx: 101.76,
    ry: 24,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.5,
    cy: 154,
    rx: 69.5,
    ry: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.717 110.23L143.58 140.182",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.22 123.334L112.625 147.67",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.283 110.23L195.42 140.182",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.78 123.334L226.374 147.67",
    stroke: "white",
    strokeWidth: 4
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M106.079 270.79C94.9532 270.79 91.6568 261.004 91.3993 256.111C92.5582 257.27 95.9576 259.201 98.7389 259.201C102.216 259.201 105.306 257.656 106.851 254.18C108.34 250.831 110.714 249.544 113.418 249.544C116.122 249.544 119.985 251.089 119.985 256.884C119.985 262.678 114.577 270.79 106.079 270.79Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 13,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.0339,
    y: 268.845,
    width: 17.7697,
    height: 13.1341,
    rx: 6.56706,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.236 256.88H119.986",
    stroke: "white",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2_lNpSezWOyvGv3Zu0fTmcJ2lZD0iUyhQfBHiDY76SSg",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 246,
    width: 34,
    height: 27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.307 270.019C94.1814 270.019 90.885 260.233 90.6274 255.34C91.7863 256.498 95.1857 258.43 97.9671 258.43C101.444 258.43 104.534 256.885 106.079 253.408C107.568 250.059 109.942 248.772 112.646 248.772C115.35 248.772 119.213 250.318 119.213 256.112C119.213 261.907 113.805 270.019 105.307 270.019Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_lNpSezWOyvGv3Zu0fTmcJ2lZD0iUyhQfBHiDY76SSg)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.169 273.105C98.0439 273.105 94.7475 263.319 94.49 258.426C95.6489 259.585 99.0483 261.516 101.83 261.516C105.306 261.516 108.397 259.971 109.942 256.494C111.43 253.145 113.805 251.859 116.509 251.859C119.213 251.859 123.076 253.404 123.076 259.198C123.076 264.993 117.668 273.105 109.169 273.105Z",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.307 270.019C94.1814 270.019 90.885 260.233 90.6274 255.34C91.7863 256.498 95.1857 258.43 97.9671 258.43C101.444 258.43 104.534 256.885 106.079 253.408C107.568 250.059 109.942 248.772 112.646 248.772C115.35 248.772 119.213 250.318 119.213 256.112C119.213 261.907 113.805 270.019 105.307 270.019Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.462 256.108H119.213",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.215 270.391V276.572",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.624 270.391V276.572",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.418,
    cy: 254.952,
    r: 1.93149,
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M300.074 42.1929H299.921C299.691 42.1929 299.461 42.1162 299.231 42.0396C298.924 41.9629 298.618 41.8863 298.311 41.8863C297.698 41.8096 297.085 42.2695 297.008 42.8827C296.932 43.4959 297.392 44.1091 298.005 44.1857C298.235 44.1857 298.465 44.2624 298.695 44.339C299.001 44.4157 299.308 44.4923 299.538 44.4923C303.063 45.3355 306.973 48.0948 307.202 52.0038C307.356 55.453 305.286 58.7489 301.531 60.7417C293.482 65.034 265.736 64.2675 250.713 63.1178C250.1 63.0412 249.563 63.5777 249.486 64.1909C249.41 64.8041 249.946 65.3406 250.56 65.4173C252.706 65.5706 263.206 66.337 274.474 66.337C285.588 66.337 297.468 65.5706 302.68 62.8112C307.202 60.3585 309.809 56.2961 309.579 51.9272C309.272 46.7151 304.443 43.266 300.074 42.1929Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M284.361 93.394C284.131 93.394 283.902 93.4707 283.595 93.5473C283.365 93.624 283.135 93.624 282.905 93.7006C282.292 93.7773 281.832 94.3138 281.909 95.0036C281.985 95.6168 282.445 96.0001 283.058 96.0001C283.135 96.0001 283.135 96.0001 283.212 96.0001C283.442 96.0001 283.748 95.9234 284.055 95.8468C284.285 95.7701 284.515 95.7701 284.745 95.6935H284.898C288.96 94.6971 293.483 91.4778 293.713 86.7256C293.942 82.5867 291.566 78.8309 287.274 76.5314C277.08 71.0894 237.146 74.0787 236.763 74.0787C236.15 74.1554 235.69 74.6919 235.69 75.3051C235.767 75.9183 236.303 76.3782 236.916 76.3782C247.877 75.535 278.153 74.3087 286.124 78.5243C289.574 80.3639 291.49 83.3531 291.336 86.5724C291.183 90.1748 287.581 92.6276 284.361 93.394Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M283.595 53.4606C281.832 54.3804 275.24 54.457 269.951 53.9971C269.338 53.9205 268.802 54.3804 268.725 55.0702C268.648 55.6834 269.108 56.2199 269.798 56.2966C270.411 56.3732 273.247 56.5265 276.39 56.5265C279.609 56.5265 283.135 56.2966 284.744 55.4535C286.277 54.6103 287.197 53.154 287.044 51.6211C286.967 49.7815 285.358 48.5551 283.748 48.1719H283.595C283.518 48.1719 283.518 48.1719 283.441 48.1719C283.365 48.1719 283.211 48.0952 283.135 48.0952C282.522 48.0186 281.908 48.4018 281.832 49.0917C281.755 49.7049 282.138 50.318 282.828 50.3947H282.905C282.982 50.3947 283.058 50.4713 283.211 50.4713C283.901 50.6246 284.668 51.1612 284.668 51.7744C284.744 52.7708 283.825 53.3073 283.595 53.4606Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M246.497 54.6098C249.103 54.6098 251.709 53.9966 254.085 52.8469C259.604 50.0876 263.206 44.5689 263.59 38.3604L263.666 36.8275L262.133 37.2107C259.987 37.7472 257.764 38.1305 255.542 38.2838C252.246 38.5904 249.87 38.4371 247.877 38.3604C245.347 38.2071 243.355 38.0538 241.285 39.1269C238.219 40.7365 236.15 44.339 235.153 49.8576L235 50.5475L235.536 51.0074C238.832 53.3068 242.665 54.6098 246.497 54.6098ZM242.435 41.1197C243.968 40.3533 245.424 40.4299 247.877 40.5832C249.87 40.7365 252.399 40.8898 255.848 40.5066C257.611 40.3533 259.451 40.0467 261.214 39.7401C260.447 44.4923 257.458 48.6313 253.166 50.7774C248.873 52.9236 243.814 52.7703 239.599 50.6241C240.978 50.6241 242.358 50.4708 243.738 50.1642C246.114 49.6277 248.413 48.7079 250.483 47.4049C251.019 47.0983 251.173 46.3318 250.866 45.7953C250.56 45.2587 249.793 45.1055 249.256 45.412C247.417 46.5618 245.424 47.4049 243.278 47.8648C241.592 48.248 239.829 48.3247 238.066 48.1714C238.832 44.5689 240.365 42.1928 242.435 41.1197Z",
    fill: "var(--color-theme_clubPrimaryLight, var(--color-theme_clubPrimaryLight-override, rgba(172,110,231,1)))"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M260.984 85.9589L257.075 89.4847C256.615 89.9446 256.538 90.6344 256.998 91.0943C257.228 91.3242 257.534 91.4775 257.841 91.4775C258.148 91.4775 258.378 91.4009 258.607 91.1709L262.517 87.6451C262.976 87.1852 263.053 86.4954 262.593 86.0355C262.21 85.5756 261.443 85.499 260.984 85.9589Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M287.887 36.521L291.796 32.9952C292.256 32.5353 292.333 31.8455 291.873 31.3856C291.413 30.9257 290.723 30.8491 290.263 31.309L286.354 34.8348C285.894 35.2947 285.818 35.9845 286.277 36.4444C286.507 36.6743 286.814 36.8276 287.121 36.8276C287.351 36.8276 287.657 36.6743 287.887 36.521Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllNoEventsstyled);
export default __webpack_public_path__ + "static/media/ill-no-events.styled.8dde0d0c.svg";
export { ForwardRef as ReactComponent };